import styled from "styled-components";

export const SeatTicketInfoConfirmStyled = styled.div`
  position: relative;
  width: 360px;
  max-width: 90vw;
  padding: 20px;
  border-radius: 16px;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  .stc_title {
    margin-bottom: 14px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_BOLD};
  }
  .stc_row {
    display: flex;
    column-gap: 10px;
    margin-bottom: 6px;
    .stc_label {
      width: 40%;
      color: ${({ theme }) => theme.COLORS.GRAY_17};
    }
    .stc_value {
      width: 60%;
      word-break: break-word;
    }
  }
  .stc_used {
    margin-top: 10px;
    padding: 8px;
    border-radius: 8px;
    background: ${({ theme }) => theme.COLORS.ORANGE_2};
    color: ${({ theme }) => theme.COLORS.RED_2};
    text-align: center;
  }
  .stc_btns {
    margin-top: 16px;
    display: flex;
    column-gap: 12px;
    > div {
      flex: 1;
    }
  }
`;
